export default __webpack_public_path__ + "static/media/united-kingdom.6900af4e.svg";